import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from './router'
import axios from './auth'
import Root from './Root.vue'
import Toasted from 'vue-toasted';
import PortalVue from 'portal-vue'
import './bugsnag.js'
import IdleVue from 'idle-vue'

/* Font Awesome */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faExclamationTriangle, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faExclamationTriangle, faCheckCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

const eventsHub = new Vue()

var idleTime = process.env.VUE_APP_FEDRAMP === "true" ? 900000 : 3600000

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: idleTime
})

Vue.use(Toasted)
Vue.use(axios)
Vue.use(PortalVue)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  el: '#index',
  router,
  axios,
  store,
  render: h => h(Root),
})
